import {CanActivateFn, CanDeactivateFn} from '@angular/router';
import {CheckoutComponent} from "../../modules/checkout/checkout.component";
import {inject} from "@angular/core";
import {MatSnackBar} from "@angular/material/snack-bar";

export const canDeactivateGuard: CanDeactivateFn<CheckoutComponent> = (component, currentRoute, currentState, nextState) => {
  if (component.tableNumberService.isInCheckoutFlow()) {
    const _snackBar = inject(MatSnackBar);
    _snackBar.open('Bitte zuerst Bestellung und Rechnung abschließen.', 'Schließen', { duration: 3000 });
    return false;
  }
  return true;
};
